import {createSelector} from "reselect";
import {getBalances} from "../account/AccountSelectors";

export const isExchangeEligible = createSelector(
  getBalances,
  (
    balance,
  ) => {
    return balance.aggregate !== 0;
  }
);